import DOM, {ElementSize} from '../../utils/dom';
import GameBodyComponentBase, {GameBodyComponentBaseParams} from './game_body_component_base';
import {CyClass} from '../../../../common/cy-classes';




interface GameBodyInIframeComponentParams extends GameBodyComponentBaseParams {
    gameUrl: string;
    allowScrolling: boolean;
    allowFullScreen: boolean;
}

export default class GameBodyInIframeComponent extends GameBodyComponentBase {
    static CLASS = 'GameBodyInIframeComponent';

    protected _gameFrame: HTMLIFrameElement;

    protected init(params: GameBodyInIframeComponentParams) {
        super.init(params);

        this._appendGameIframe(params.gameUrl, params.allowScrolling, params.allowFullScreen);
    }

    protected _onLoad() {
    }

    private _appendGameIframe(gameUrl: string, allowScrolling: boolean, allowFullScreen: boolean): void {
        this._gameFrame = DOM.createElement('iframe') as HTMLIFrameElement;

        if(allowScrolling) {
            DOM.addAttribute(this._gameFrame, 'scrolling', 'yes');
            DOM.addStyle(this._gameFrame, 'overflow', 'scroll');
        } else {
            DOM.addAttribute(this._gameFrame, 'scrolling', 'no');
        }

        if(allowFullScreen) {
            DOM.addAttribute(this._gameFrame, 'allowfullscreen');
        }

        DOM.addAttribute(this._gameFrame, 'allow', 'autoplay');
        DOM.addClass(this._gameFrame, 'cgp-game-iframe');
        DOM.addClass(this._gameFrame, CyClass('cy-game-iframe'));

        this._gameFrame.addEventListener("load", () => {
            this._onLoad();
        });

        this._gameFrame.src = gameUrl;
        this.getEl().appendChild(this._gameFrame);
    }

    protected _setGameBodySize(gameSize: ElementSize): void {
        DOM.setElementSize(this._gameFrame, gameSize);
    }

    sendMessageToGame(message) {
        this.serviceFactory.postMessageService().sendPostMessage(this._gameFrame.contentWindow, message);
    }
}